import React from "react";

const Card2 = () => {
  return (
    <div style={{fontFamily: '"Lato", sans-serif'}} className="w-full overflow-hidden">
      <div className="bg-gradient-to-b from-[#000000] to-[#373333] h-fit">
        <div className="md:w-[75%] sm:w-[90%]   mx-auto sm:text-[14px] md:text-[21px] font-semibold tracking-wider text-center text-[#D9D9D9] py-8">
          We strive to deliver the Semicon Products at an affordable cost and
          highest quality and meet the needs of the humankind. We work to become
          a global hub for semiconductor production, focusing on reducing import
          dependence and fostering innovation in technology.
        </div>
      </div>
    </div>
  );
};

export default Card2;
